import { Component, EventEmitter, Output } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-confirmation-delete-modal",
  templateUrl: "./confirmation-delete-modal.component.html",
  styleUrls: ["./confirmation-delete-modal.component.scss"],
})
export class ConfirmationDeleteModal {
  @Output() confirmEvent = new EventEmitter<void>();
  @Output() cancelEvent = new EventEmitter<void>();

  constructor(public dialogRef: MatDialogRef<ConfirmationDeleteModal>) {}

  cancel() {
    this.cancelEvent.emit();
  }

  confirm() {
    this.confirmEvent.emit();
  }
}
